import React from 'react';
import ProcessedClients from '../components/ProcessedClients';

export default function ProcessedClientsPage() {
	return (
		<div className="processed-clients-page">
			<h2>Processed Clients</h2>
			<p className="page-subtitle">Manage clients that have been processed through the credit check system.</p>
			<ProcessedClients />
		</div>
	);
}
